import { readCheckScope, submissionKey } from '../../../features/checks/checkScope';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchChecklistBySlug, fetchSubmissionByDate, submitChecklistData } from '../../../features/checks/checkActions';
import { getLocalTodayString } from '../../../components/CreationDate';
import Toast from '../../../components/Toast';

export default function useCheckSignOff({ checklistId, creationDate = getLocalTodayString(), approved, fields = {}, slug }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const template = useSelector(state => slug ? state.checks.checklistsBySlug[slug] : null);
    const id = checklistId || template?.id;
    const record = useSelector(state => state.checks.submissionsByDate[submissionKey(id, creationDate, readCheckScope().locationCode)]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const inFlight = useRef(false);
    useEffect(() => {
        if (slug) dispatch(fetchChecklistBySlug(slug));
    }, [dispatch, slug]);
    useEffect(() => {
        if (slug && id) dispatch(fetchSubmissionByDate({ checklistId: id, creationDate }));
    }, [dispatch, slug, id, creationDate]);
    const canSubmit = approved === true && Boolean(id) && !record?.loading && !isSubmitting;
    const submit = async event => {
        event?.preventDefault();
        if (!canSubmit || inFlight.current) return;
        inFlight.current = true;
        setIsSubmitting(true);
        const data = new FormData();
        data.append('checklistId', id);
        data.append('creationDate', creationDate);
        data.append('isClosedSecured', 'true');
        data.append('signOff', 'true');
        Object.entries(fields).forEach(([key, value]) => {
            if (value !== undefined && value !== null) data.append(key, value);
        });
        try {
            await dispatch(submitChecklistData(data)).unwrap();
            Toast('success', 'Check Submitted');
            navigate('/checks');
        } catch (error) {
            Toast('error', error || 'Failed to submit check. Please try again.');
        } finally {
            inFlight.current = false;
            setIsSubmitting(false);
        }
    };
    return { canSubmit, isSubmitting, submit, submission: record?.data };
}

